// extracted by mini-css-extract-plugin
export var Title = "SectionInfoCard-module--Title--061ea";
export var card = "SectionInfoCard-module--card--2f883";
export var contentContainer = "SectionInfoCard-module--content-container--e64a9";
export var description = "SectionInfoCard-module--description--ff0fb";
export var logoImage = "SectionInfoCard-module--logo-image--da6ec";
export var subTitle = "SectionInfoCard-module--subTitle--4bc9d";
export var thumbnailImage = "SectionInfoCard-module--thumbnail-image--5cef6";